export const AUTH_ERROR = 'AUTH/AUTH_ERROR';
export const LOGIN_SUCCESS = 'AUTH/LOGIN_SUCCESS';
export const LOGIN_FAIL = 'AUTH/LOGIN_FAIL';
export const LOGOUT_SUCCESS = 'AUTH/LOGOUT_SUCCESS';
export const REGISTER_SUCCESS = 'AUTH/REGISTER_SUCCESS';
export const REGISTER_FAIL = 'AUTH/REGISTER_FAIL';
export const REFRESH_TOKEN = 'AUTH/REFRESH_TOKEN';
export const SET_USER_DATA = 'AUTH/SET_USER_DATA';
